import { Badge } from "./badge";

/**
 * Унифицированный rule-chip primitive (фича 024 — Phase 5a).
 *
 * До рефакторинга три определения: DiscrepancyDeltaPills, DiscrepancyCard,
 * DiscrepancyMatrixCard — каждое со слегка разными классами. Унифицировано:
 * outline-badge с mono-шрифтом.
 */
export function RuleChip({ children }: { children: React.ReactNode }) {
	return (
		<Badge
			variant="outline"
			className="font-mono text-[10px] uppercase tracking-wide text-slate-700"
		>
			{children}
		</Badge>
	);
}
